/**
 * Formatta le unità di misura per la visualizzazione nell'UI.
 * Converte valori tecnici in etichette user-friendly.
 * Uniforma: sempre "t" per tonnellate, sempre "tep" per TEP.
 */
export const formatUnitOfMeasurement = (udm: string | null | undefined): string => {
  if (!udm) return '';

  const trimmed = udm.trim();
  const lower = trimmed.toLowerCase();

  // Uniformazione: tonnellate → "t", TEP → "tep"
  if (
    lower === 'ton' ||
    lower === 'tonn' ||
    lower === 'tonnellate' ||
    lower === 'tonnellata' ||
    lower === 'tons'
  ) {
    return 't';
  }

  // Mappatura per valori tecnici -> etichette UI (come per °C: valore interno -> label)
  const udmMap: Record<string, string> = {
    Pz: 'Pezzi',
    C: '°C',
    m3: 'm³',
    Sm3: 'Sm³',
    Nm3: 'Nm³',
    cm3: 'cm³',
    m2: 'm²',
    cm2: 'cm²',
    km2: 'km²',
  };

  return udmMap[trimmed] || udmMap[lower] || trimmed;
};
